"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _atoms = require("../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Input = function Input(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFocused = _useState2[0],
      setIsFocused = _useState2[1];

  var iconLeft = props.iconLeft ? /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: 16,
    type: props.iconLeft
  }) : null;
  var iconRight = props.iconRight ? /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: 16,
    type: props.iconRight
  }) : null;
  var containerClass = "Input";
  var inputClass = "";
  var tag = "input";
  var type = props.type;

  var onClear = function onClear(e) {
    if (props.onChange) {
      props.onChange("", props.name);
    }
  };

  if (props.className) {
    containerClass += " " + props.className;
  }

  if (props.error) {
    containerClass += " error";
  }

  if (props.clear) {
    iconRight = /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      type: _atoms.Icon.Type.Close,
      size: 16,
      color: "#CACCCC",
      onClick: onClear
    });
  }

  if (props.iconLeft) {
    inputClass += " icon-on-left";
  }

  if (props.iconRight) {
    inputClass += " icon-on-right";
  }

  if (isFocused) {
    containerClass += " focused";
  }

  if (props.type === Input.Type.LongText) {
    tag = 'textarea';
    type = 'text';
  }

  var attr = Object.assign({
    span: "12"
  }, props);
  delete attr.name;
  delete attr.optional;
  delete attr.description;
  delete attr.label;
  delete attr.help;
  delete attr.type;
  delete attr.placeholder;
  delete attr.maxlength;
  delete attr.value;
  delete attr.error;
  delete attr.onFocus;
  delete attr.onBlur;
  delete attr.onChange;
  delete attr.icon;
  delete attr.disabled;
  delete attr.iconLeft;
  delete attr.iconRight;
  console.log("Input", tag, type);
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, _extends({}, attr, {
    className: containerClass
  }), (props.label || props.optional) && /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    span: "12"
  }, props.label && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    small: true,
    color: _atoms.Label.Color.Charcoal50,
    content: props.label
  }), props.optional && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    color: _atoms.Label.Color.Charcoal50,
    small: true,
    content: "*Optional"
  })), props.description && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    type: _atoms.Label.Type.Body,
    color: _atoms.Label.Color.Charcoal50,
    small: true,
    content: props.description
  }), /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "input-wrapper"
  }, iconLeft && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "icon-left"
  }, iconLeft), iconRight && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: "icon-right"
  }, iconRight), tag === 'input' && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: inputClass,
    tag: tag,
    name: props.name,
    type: props.type,
    value: props.value ? props.value : '',
    disabled: props.disabled ? "disabled" : null,
    placeholder: props.placeholder,
    maxlength: props.maxlength,
    inputmode: props.type === "number" ? "numeric" : "text",
    onFocus: function onFocus(e) {
      setIsFocused(true);

      if (props.onFocus) {
        props.onFocus(props.name);
      }
    },
    onBlur: function onBlur(e) {
      setIsFocused(false);

      if (props.onBlur) {
        props.onBlur(props.name);
      }
    },
    onChange: function onChange(e) {
      if (props.onChange) {
        props.onChange(e.currentTarget.value, props.name);
      }
    }
  }), tag === 'textarea' && /*#__PURE__*/_react.default.createElement(_atoms.Element, {
    className: inputClass,
    tag: tag,
    name: props.name,
    disabled: props.disabled ? "disabled" : null,
    onFocus: function onFocus(e) {
      setIsFocused(true);

      if (props.onFocus) {
        props.onFocus(props.name);
      }
    },
    onBlur: function onBlur(e) {
      setIsFocused(false);

      if (props.onBlur) {
        props.onBlur(props.name);
      }
    },
    onChange: function onChange(e) {
      if (props.onChange) {
        props.onChange(e.currentTarget.value, props.name);
      }
    }
  })), (props.error || props.help) && /*#__PURE__*/_react.default.createElement(_atoms.Column, null, props.error && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    span: "6",
    left: true,
    type: _atoms.Label.Type.Body,
    color: _atoms.Label.Color.Error,
    small: true,
    semi: true,
    content: props.error
  }), props.help && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    span: "6",
    left: true,
    type: _atoms.Label.Type.Body,
    small: true,
    content: props.help,
    color: _atoms.Label.Color.Charcoal40
  })));
};

exports.Input = Input;
Input.Type = {
  Text: 'text',
  LongText: 'longtext',
  Number: 'number',
  Date: 'date',
  Color: 'color',
  Email: 'email',
  Password: 'password',
  Search: 'Search',
  URL: 'url'
};
Input.propTypes = {
  name: _propTypes.default.string,
  label: _propTypes.default.string,
  optional: _propTypes.default.bool,
  description: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  maxlength: _propTypes.default.number,
  help: _propTypes.default.string,
  error: _propTypes.default.string,
  type: _propTypes.default.oneOf([Input.Type.Text, Input.Type.Number, Input.Type.Date, Input.Type.Color, Input.Type.Email, Input.Type.Password, Input.Type.Search, Input.Type.URL]).isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  iconLeft: _propTypes.default.string,
  iconRight: _propTypes.default.string,
  clear: _propTypes.default.bool
};